const Utils = {
  flattenDrawerList(
    items: { slug?: string; name?: string; children?: any[] }[],
    parentPath: string = ""
  ): Record<string, string> {
    const flatObj: Record<string, string> = {};

    const flatten = (
      items: { slug?: string; name?: string; children?: any[] }[] = [],
      parentName: string = ""
    ): void => {
      items.forEach((item) => {
        if (item.slug && item.name) {
          // Normalize the slug by removing leading slashes
          const normalizedSlug = item.slug.replace(/^\//, "");
          flatObj[normalizedSlug] = parentName
            ? `${parentName} / ${item.name}` // Add "/" separator
            : item.name;

          flatten(item.children || [], flatObj[normalizedSlug]);
        }
      });
    };

    flatten(items);

    return flatObj;
  },
};

export default Utils;
